import React from "react";

const Imprint = () => {
  return (
    <div className="imprint">
      <div className="imprintText">
        <div className="contact">
          <br />
          <h2>Matteo Rosoli</h2> <br />
          E-Mail:{" "}
          <a className="headerLink" href="mailto:office@matteorosoli.at">
            office@matteorosoli.at
          </a>{" "}
        </div>
        <div className="uhrheberrecht">
          <br />
          <h2>Inhalt der Website</h2> <br />
          Dies ist eine private Website die nur zur Information dient. Alle
          Rechte sind vorbehalten und es gilt das gesetzliche Urheberrecht. Eine
          Weiterverwendung und Reproduktion meiner Inhalte ist nicht gestattet.
          <br />
          Website von <b>Matteo Rosoli</b>.
          <br />
          Logo und Art von <b>Matteo Rosoli</b> und <b>Ian Memic</b>.
          <br />
          SVG Animation: Generated by SVG Artista on 1/7/2025, 4:49:41 PM,{" "}
          <a
            className="headerLink"
            href="https://opensource.org/licenses/MIT"
            target="_blank"
            rel="noopener noreferrer"
          >
            MIT License
          </a>
          , W.
          <a
            className="headerLink"
            href="https://svgartista.net"
            target="_blank"
            rel="noopener noreferrer"
          >
            SVG Artista
          </a>
          <br />
          <br />
          <h2>Urheberrecht</h2>
          Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen
          Seiten unterliegen dem österreichischen Urheberrecht. Die
          Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung
          außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
          Zustimmung des jeweiligen Autors bzw. Erstellers.
          <br />
        </div>
      </div>
    </div>
  );
};

export default Imprint;
